'use client';
import { useState, useEffect } from 'react';
import styles from './exit-intent-modal.module.css';
import useModal from '../use-modal';
import Modal from '../modal';
import { useSession } from 'next-auth/react';
import Image from 'next/image';
import Link from 'next/link';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRightFromBracket } from '@awesome.me/kit-012d1b9af0/icons/classic/regular';

export default function ExitIntentModal() {
	const { isOpen, onOpen, onClose } = useModal();
	const { status } = useSession();
	const [hasBeenAsked, setHasBeenAsked] = useState(false);

	useEffect(() => {
		const handleMouseLeave = (e: MouseEvent) => {
			const isAuthenticated = status === 'authenticated';

			if (!hasBeenAsked && !isAuthenticated && e.clientY < 1) {
				onOpen('exit-intent');
				setHasBeenAsked(true);
			}
		};

		document.addEventListener('mouseleave', handleMouseLeave);

		return () => {
			document.removeEventListener('mouseleave', handleMouseLeave);
		};
	}, [onOpen, hasBeenAsked, status]);

	const handleMaybeLater = () => {
		onClose('exit-intent');
	};

	const handleSignUp = () => {
		onClose('exit-intent');
	};

	if (status === 'loading') {
		return null;
	}

	return (
		<Modal isOpen={isOpen('exit-intent')} onClose={handleMaybeLater} auto>
			<Modal.Body>
				<div className={styles.body}>
					<div className={styles['side-image']}>
						<Image src={'/leaving.png'} alt='leaving' fill />
					</div>

					<div className={styles['body-content']}>
						<div className={styles.header}>
							<p className={styles.title}>HANG ON!</p>
							<p className={styles.subtitle}>DON'T LEAVE JUST YET</p>
						</div>

						<div className={styles.content}>
							<p className={styles.message}>Don't miss out on future trials</p>
							<p className={styles.description}>
								Sign up and we will email you about new trials you might be
								interested in!
							</p>
							<p className={styles.note}>It's only going to take 30 seconds</p>
						</div>

						<div className={styles.buttons}>
							<button onClick={handleMaybeLater} className={styles.later}>
								MAYBE LATER
							</button>
							<Link href='/auth' className={styles.sign} onClick={handleSignUp}>
								SIGN UP <FontAwesomeIcon icon={faRightFromBracket} size='lg' />
							</Link>
						</div>
					</div>
				</div>
			</Modal.Body>
		</Modal>
	);
}
